// extracted by mini-css-extract-plugin
export default {"sendAds":"ads_sendAds__FrBWq","ads":"ads_ads__6EVra","file":"ads_file__+cGsq"};